import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UnlockedBoekeStudent, UnlockedBoekeStudentInterface } from '../../+models';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './unlocked-boeke-student.reducer';

export const selectUnlockedBoekeStudentState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectUnlockedBoekeStudentState, (state: State) => state.error);

export const getLoaded = createSelector(selectUnlockedBoekeStudentState, (state: State) => state.loaded);

export const getAll = createSelector(selectUnlockedBoekeStudentState, selectAll);

export const getCount = createSelector(selectUnlockedBoekeStudentState, selectTotal);

export const getIds = createSelector(selectUnlockedBoekeStudentState, selectIds);

export const getAllEntities = createSelector(selectUnlockedBoekeStudentState, selectEntities);

/**
 * returns array of objects in the order of the given ids
 * @example
 * unlockedBoekeStudent$: UnlockedBoekeStudentInterface[] = this.store.pipe(
    select(UnlockedBoekeStudentQueries.getByIds, { ids: [2, 1, 3] })
  );
 */
export const getByIds = createSelector(selectUnlockedBoekeStudentState, (state: State, props: { ids: number[] }) => {
  return props.ids.map((id) => state.entities[id]);
});

/**
 * returns array of objects in the order of the given ids
 * @example
 * unlockedBoekeStudent$: UnlockedBoekeStudentInterface = this.store.pipe(
    select(UnlockedBoekeStudentQueries.getById, { id: 3 })
  );
 */
export const getById = createSelector(
  selectUnlockedBoekeStudentState,
  (state: State, props: { id: number }) => state.entities[props.id]
);

export const getShared = createSelector(selectUnlockedBoekeStudentState, (state: State, props: { userId: number }) => {
  const ids: number[] = <number[]>state.ids;
  return ids
    .filter((id) => !asUnlockedBoekeStudent(state.entities[id]).isOwn(props.userId))
    .map((id) => state.entities[id]);
});

export const getOwn = createSelector(selectUnlockedBoekeStudentState, (state: State, props: { userId: number }) => {
  const ids: number[] = <number[]>state.ids;
  return ids
    .filter((id) => asUnlockedBoekeStudent(state.entities[id]).isOwn(props.userId))
    .map((id) => state.entities[id]);
});

function asUnlockedBoekeStudent(item: UnlockedBoekeStudentInterface): UnlockedBoekeStudent {
  if (item) {
    return Object.assign<UnlockedBoekeStudent, UnlockedBoekeStudentInterface>(new UnlockedBoekeStudent(), item);
  }
}
